import React from 'react';
import { Section } from './Shared';
import { volumes } from '../data/landing';
export const Volumes = () => <Section id="volumenes" className="max-w-5xl" data-id="element-233" data-mp="1lvjr8b5ygs43">
    <h2 className="text-[28px] md:text-5xl font-display font-bold leading-tight text-brand-purpleDark text-center max-w-3xl mx-auto" data-id="element-234" data-mp="1lxcynsoe7gd5">
      📚 Cinco volúmenes para darle más estructura a tu práctica
    </h2>

    <ol className="mt-10 md:mt-14 divide-y divide-brand-purple/15 border-y border-brand-purple/15" data-id="element-235" data-mp="1c34ebs9imtq2">
      {volumes.map(vol => <li key={vol.label} className="py-8 md:py-10 flex flex-col sm:flex-row gap-6 md:gap-10 items-center sm:items-start" data-id="element-236" data-mp="24ue7xpozc2mw">
          <img src={vol.cover} alt={`Portada del ${vol.label}: ${vol.title}`} loading="lazy" className="w-32 md:w-40 shrink-0 aspect-[9/16] object-cover rounded-lg shadow-[0_10px_24px_rgba(23,61,31,0.28)] ring-1 ring-brand-gold/40" data-id="element-237" data-mp="1qwhcwxq6c4ac" />
          <div className="text-center sm:text-left" data-id="element-238" data-mp="kc7xkgkc44xi">
            <p className="text-xs md:text-sm font-bold tracking-[0.14em] text-brand-goldDark uppercase" data-id="element-239" data-mp="3o7dev8xn6ype">
              {vol.emoji} {vol.label}
            </p>
            <h3 className="font-serif font-bold text-xl md:text-2xl text-brand-purpleDark mt-1 leading-snug" data-id="element-240" data-mp="3jbg91wk09aqv">
              {vol.title}
            </h3>
            <p className="text-base md:text-lg text-brand-text mt-3 leading-relaxed" data-id="element-241" data-mp="3t6gj4r5st0wb">
              {vol.description}
            </p>
            <p className="font-display italic text-lg md:text-xl text-brand-purple mt-3" data-id="element-242" data-mp="azjzl4yz90dc">
              {vol.takeaway}
            </p>
          </div>
        </li>)}
    </ol>
  </Section>;